'use strict';

var React = require("react");

var initialState = {
  action: /* None */0,
  form: /* [] */0
};

function initialContext_1(param) {
  
}

var initialContext = [
  initialState,
  initialContext_1
];

var context = React.createContext(initialContext);

var make = context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

var Provider = {
  make: make,
  makeProps: makeProps
};

exports.initialState = initialState;
exports.initialContext = initialContext;
exports.context = context;
exports.Provider = Provider;
/* context Not a pure module */
